module.exports = __webpack_public_path__ + "static/img/nullData.c3866447.png";